import {
  SingleDatePicker,
  type SingleDatePickerProperties,
} from "@jetblue/kit/date-picker";
import { useBestFaresRenderDate } from "./render-date";
import type { BestFaresCalendarQueryInput } from "../../hooks/use-best-fares-calendar";

export type BestFaresSingleDatePickerProperties = Pick<
  SingleDatePickerProperties,
  | "className"
  | "endDate"
  | "error"
  | "labels"
  | "selectedDate"
  | "setSelectedDate"
  | "showValidation"
  | "startDate"
> &
  BestFaresCalendarQueryInput & {
    showDatePickerPricing: boolean;
  };
export const BestFaresSingleDatePicker = ({
  destination,
  origin,
  passengers,
  showDatePickerPricing,
  usePoints,
  ...singleDatePickerProperties
}: BestFaresSingleDatePickerProperties) => {
  const { endDate, startDate } = singleDatePickerProperties;

  const renderDate = useBestFaresRenderDate({
    destination,
    endDate,
    fareDirection: "outbound",
    origin,
    passengers,
    showDatePickerPricing,
    startDate,
    tripType: "one-way",
    usePoints,
  });

  return (
    <SingleDatePicker {...singleDatePickerProperties} renderDate={renderDate} />
  );
};
